/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Secretary } from './Secretary';
import {
    SecretaryFromJSON,
    SecretaryFromJSONTyped,
    SecretaryToJSON,
} from './Secretary';

/**
 * 
 * @export
 * @interface SecretariesResponse
 */
export interface SecretariesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SecretariesResponse
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof SecretariesResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof SecretariesResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {Array<Secretary>}
     * @memberof SecretariesResponse
     */
    data: Array<Secretary>;
}

/**
 * Check if a given object implements the SecretariesResponse interface.
 */
export function instanceOfSecretariesResponse(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    if (!('data' in value)) return false;
    return true;
}

export function SecretariesResponseFromJSON(json: any): SecretariesResponse {
    return SecretariesResponseFromJSONTyped(json, false);
}

export function SecretariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecretariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': ((json['data'] as Array<any>).map(SecretaryFromJSON)),
    };
}

export function SecretariesResponseToJSON(value?: SecretariesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': ((value['data'] as Array<any>).map(SecretaryToJSON)),
    };
}

